export { default } from './ModalSettingMerchant';
